import React from 'react';
import callBg from '../../../assets/site/bg-call.jpg';
import Section from '../components/Section';
import { contact } from '../data/contact';
import cx from '../utils/cx';
import ui from '../styles/primitives.module.css';
import styles from './ScheduleCall.module.css';

const ScheduleCall = ({ eyebrow = 'Schedule a call' }) => (
  <Section id="call" background={callBg} backgroundPosition="center 55%">
    <div className={cx(ui.wrap, styles.grid)}>
      <div data-reveal="">
        <span className={ui.eyebrow}>{eyebrow}</span>
        <h2 className={styles.title}>
          Let’s talk about <span className={ui.grad}>what you want to build</span>
        </h2>
        <p className={styles.lede}>
          Tell us your goals and we’ll show you the opportunities that fit. No pressure, just a conversation.
        </p>
      </div>

      <div className={cx(styles.panel, ui.glass)} data-reveal="">
        <a className={cx(ui.btn, ui.btnPrimary)} href={contact.calendlyUrl} target="_blank" rel="noopener noreferrer">
          Book a time
        </a>
        <div className={styles.row}>
          <span>Email</span>
          <a href={contact.emailHref}>{contact.email}</a>
        </div>
        <div className={styles.row}>
          <span>Phone</span>
          <a href={contact.phoneHref}>{contact.phoneDisplay}</a>
        </div>
        <div className={styles.row}>
          <span>Website</span>
          <span className={styles.value}>{contact.website}</span>
        </div>
      </div>
    </div>
  </Section>
);

export default ScheduleCall;
